import React, { PropTypes, Component } from 'react';
import Translate from '../layout/Translate';

export default class PhotoView extends Component {

    componentDidMount() {
        //console.log(this.props.photo);
        
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }

    selectMapPhoto(photo) {
        this.props.actions.selectMapPhoto(photo);
    }
    nextMapPhoto(photo) {
        if (!photo.single) {
            this.props.actions.nextMapPhoto(photo);
        } else {
            this.props.actions.selectMapPhoto(null);
        }
    }
    prevMapPhoto(photo) {
        this.props.actions.prevMapPhoto(photo);
    }

    render () {
        let {photo, width} = this.props;
        let photoSize = 1000;
        let sizes = [1000, 1400, 1920];
        sizes.forEach(function(size){
            if (width > size) {
                photoSize = size;
            }
        });


        return (
            <div className={"lightbox"}>
                <div className={"lightbox__cell"}>
                <div className={"lightbox__popup"}>
                        <div className={"lightbox__photo"}>
                            {(!!(this.props.index%2) && this.props.photo.thumbnails) &&
                                <img alt={photo.title} data-id={photo.id} className={"lightbox__image " + (this.props.photo.title?"lightbox__image_short":"")} onClick={this.nextMapPhoto.bind(this, photo)} src={
                                        (this.props.photo.thumbnails['browsing' + photoSize])?this.props.photo.thumbnails['browsing' + photoSize].url:(this.props.photo.thumbnails.map200)?this.props.photo.thumbnails.map200.url:''
                                    } />
                            }
                            {(!(this.props.index%2) && this.props.photo.thumbnails) &&
                                <img data-id={photo.id} alt={photo.title} className={"lightbox__image " + (this.props.photo.title?"lightbox__image_short":"")} onClick={this.nextMapPhoto.bind(this, photo)} src={
                                        (this.props.photo.thumbnails['browsing' + photoSize])?this.props.photo.thumbnails['browsing' + photoSize].url:(this.props.photo.thumbnails.map200)?this.props.photo.thumbnails.map200.url:''
                                    } />
                            }

                            <div className={"lightbox__close"}  onClick={this.selectMapPhoto.bind(this, null)}></div>
                            {!photo.single &&
                                <div className={"lightbox__next"}  onClick={this.nextMapPhoto.bind(this, photo)}></div>
                            }
                            {!photo.single &&
                                <div className={"lightbox__prev"} onClick={this.prevMapPhoto.bind(this, photo)}></div>
                            }
                    </div>
                    {this.props.photo.prev && this.props.photo.prev.thumbnails &&
                        <img width="100" height="100" className="lightbox__preload" src={
                            (this.props.photo.prev.thumbnails['browsing' + photoSize])?this.props.photo.prev.thumbnails['browsing' + photoSize].url:(this.props.photo.prev.thumbnails.map200)?this.props.photo.prev.thumbnails.map200.url:''
                         } />
                    }
                    {this.props.photo.next && this.props.photo.next.thumbnails &&
                        <img width="100" height="100" className="lightbox__preload" src={
                            (this.props.photo.next.thumbnails['browsing' + photoSize])?this.props.photo.next.thumbnails['browsing' + photoSize].url:(this.props.photo.next.thumbnails.map200)?this.props.photo.next.thumbnails.map200.url:''
                         } />
                    }

                    {(this.props.photo.title || (!photo.single)) &&
                        <div className={"lightbox__title"}>
                            {this.props.photo.title}
                            {!photo.single &&
                                <span className="lightbox__author">&#9400; <Translate slug="photo__author"/></span>
                            }
                        </div>
                    }
                    <div className={"lightbox__close"}  onClick={this.selectMapPhoto.bind(this, null)}></div>
                </div>
                <div className={"lightbox__background"}  onClick={this.selectMapPhoto.bind(this, null)}></div>
                </div>
            </div>



        );
    }
};



// WEBPACK FOOTER //
// ./src/common/components/map/PhotoView.js